<mc-navbar></mc-navbar>
<router-outlet></router-outlet>
<div class="footer pl-1">
  <small>{{version}}</small>
</div>
